export const tailwindOverride = `
.tailwind-override * {
    all: revert;
}
.tailwind-override tbody tr:first-child td {
    color: #fff;
    background-color: #666;
}
.tailwind-override td {
    border: 1px solid #ddd;
    padding: 0px 12px;
    margin: 0;
}
`;
